module.exports = __webpack_public_path__ + "static/media/logo.af270ee9.png";